<template>
  <Loader v-if="loader" />
  <div class="table-container">
    <div class="card">
      <div class="flex justify-content-between">
        <h4>Portale delle pratiche</h4>
        <Button @click="visibleFilePratiche = true" v-tooltip.left="`Gestisci file pratiche`" icon="pi pi-folder-open"/>
      </div>
      <div>
        <div class="flex flex-wrap">
          <Button
            v-for="pratica in filteredPratiche"
            :key="pratica.name"
            :class="`m-2 btn-filter flex justify-content-center ${pratica.selected ? 'selected' : ''}`"
            @click="showComponent(pratica)"
          >
            {{ pratica.name }}
            <span
              v-if="pratica.key && getCount(pratica.key, 'pod') > 0"
              class="badge-notifica badge-pod"
              v-tooltip.left="'POD non lavorate'"
            >
              {{ getCount(pratica.key, 'pod') }}
            </span>
            <span
              v-if="pratica.key && getCount(pratica.key, 'pdr') > 0"
              class="badge-notifica badge-pdr"
              v-tooltip.left="'PDR non lavorate'"
            >
              {{ getCount(pratica.key, 'pdr') }}
            </span>
            <span
              v-if="pratica.key === 'stallo_incall' && stalloCount > 0"
              class="badge-notifica badge-stallo"
              v-tooltip.left="'Pratiche firmate da confermare'"
            >
              {{ stalloCount }}
            </span>
          </Button>
        </div>
        <component :is="currentComponent" :data="currentData" :stati="stati"></component>
      </div>
    </div>
  </div>
  <Dialog v-model:visible="visibleFilePratiche" modal :style="{ width: '75%' }" maximizable >
    <FilePratiche />
  </Dialog>
</template>
<script>
import { ref, onMounted, computed} from "vue";
//import { useStore } from 'vuex';
import Cessazione from "./Cessazione.vue";
import ModificaMc1 from "./ModificaMc1.vue";
import ModificaPosaContatore from "./ModificaPosaContatore.vue";
import PraticaVoltura from "./PraticaVoltura.vue";
import PraticaSubentro from "./PraticaSubentro.vue";
import PraticaAttivazionePreposato from "./PraticaAttivazionePreposato.vue";
import PraticaSpostamentoContatore from "./PraticaSpostamentoContatore.vue";
import PraticaVerificaContatore from "./PraticaVerificaContatore.vue";
import PraticaVT4 from "./PraticaVT4.vue";
import logPratiche from "./logPratiche.vue";
import FilePratiche from "./FilePratiche.vue";
import PraticheStalloIncall from "./PraticheStalloIncall.vue";
import Loader from "@/components/Loader.vue";
import Service from "@/services/ask-pratiche/gestione-pratiche";
import { ordinaStati } from "@/services/ask-pratiche/preventivoFirmato";
export default {
  components: {
    Cessazione,
    ModificaMc1,
    ModificaPosaContatore,
    PraticaVoltura,
    PraticaSubentro,
    PraticaAttivazionePreposato,
    PraticaSpostamentoContatore,
    PraticaVT4,
    Loader,
    FilePratiche,
    logPratiche,
  },
  setup() {
   // const store = useStore();
    const loader = ref(false);
    const service = new Service();
    const pratiche = ref([
      {name: "Da confermare", key: "stallo_incall", component: PraticheStalloIncall, data:[], loaded: false, selected: false, method: 'getListPraticheStalloIncall', profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Cessazione", key: "cessazione", component: Cessazione, data:[], loaded: false, selected: false, method: 'getListCessazione', profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Mc1", key: "mc1", component: ModificaMc1, data:[], loaded: false, selected: false, method: 'getListModificaMc1', profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Posa contatore", key: "posa_contatore", component: ModificaPosaContatore, data:[], loaded: false, selected: false, method: 'getListModificaPosaContatore', profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Spostamento contatore", key: "spostamento_contatore", component: PraticaSpostamentoContatore, data:[], loaded: false, selected: false, method: 'getListSpostamentoContatore', profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Verifica contatore", key: "verifica_contatore", component: PraticaVerificaContatore, data:[], loaded: false, selected: false, method: 'getListVerificaContatore', profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Voltura", key: "voltura", component: PraticaVoltura, data:[], loaded: false, selected: false, profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Subentro", key: "subentro", component: PraticaSubentro, data:[], loaded: false, selected: false, profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Attivazione su Preposato", key: "attivazione_preposato", component: PraticaAttivazionePreposato, data:[], loaded: false, selected: false, profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Voltura Titolo IV", key: "vt4", component: PraticaVT4, data:[], loaded: false, selected: false, profiles: ['all', 'pratiche', 'backoffice', 'credito']},
      {name: "Info Pratiche", key: "info_pratiche", component: logPratiche, data:[], loaded: false, selected: false, method: 'getPraticheStats', profiles: ['all', 'pratiche', 'backoffice', 'credito']}    
    ])
    const file = ref({
      name: "File",
      component: FilePratiche,
      data:[]
    })
    const stati = ref([])
    const currentComponent = ref(null);
    const currentData = ref(null);
    const visibleFilePratiche = ref(false)
    const praticheCounts = ref({})
    const stalloCount = ref(0)
    const showComponent = async (pratica) => {
      if (pratica.key === 'stallo_incall') {
        pratica.loaded = false
      }
      if (!pratica.loaded && pratica.method) {
        let method = pratica.method
        loader.value = true;
        await service[method]()
        .then(res => {
          if (pratica.key === 'stallo_incall' && res && !Array.isArray(res)) {
            pratica.data = res.pending || []
            pratica.rejected = res.rejected || []
            return
          }
          pratica.data = res          
        })
        .finally(()=>{
          pratica.loaded = true
          loader.value = false;
          if (pratica.key === 'stallo_incall') {
            stalloCount.value = Array.isArray(pratica.data) ? pratica.data.length : 0
          }
        })
      }
      let index = pratiche.value.findIndex(type => type.name == pratica.name)
      pratiche.value.forEach((el, i)=>{
        el.selected = i == index ? true : false
      })
      currentComponent.value = pratica.component;
      currentData.value = pratica.data;
    };
    const getTypesStatoPratica = async () => {
      await service.getTypesStatoPratica()
      .then((res)=>{
        stati.value = ordinaStati(res.items)
        // stati.value.unshift({id: 0, stato: 'Non lavorato'})
      })
    }

    const getCountPraticheNonLavorate = async () => {
      try {
        const res = await service.getCountPraticheNonLavorate()
        if (res && res.dettaglio) {
          praticheCounts.value = res.dettaglio
        }
      } catch (error) {
        console.error('Errore nel recupero del conteggio pratiche non lavorate:', error)
      }
    }
    const getCountPraticheStallo = async () => {
      try {
        stalloCount.value = await service.getCountPraticheStalloIncall()
      } catch (error) {
        console.error('Errore nel recupero del conteggio pratiche da confermare:', error)
      }
    }
    const getCount = (key, tipo) => {
      const d = praticheCounts.value[key]
      if (!d || typeof d !== 'object') return 0
      return d[tipo] != null ? Number(d[tipo]) : 0
    }
    const userProfile = computed(() => {
      
      const userLoggedStorage = localStorage.getItem('user');
      
      if (!userLoggedStorage) {
        return null;
      }
        
      try {
        const decodedUser = JSON.parse(atob(userLoggedStorage));
        const profile = decodedUser.user[0].profile;
        return profile;
      } catch (error) {
        console.error('Error parsing user profile:', error);
        return null;
      }
    });
    const hasAccess = (requiredProfiles) => {
      const profile = userProfile.value;
      
      if (!profile) {   
        return false;
      }

      return requiredProfiles.some(reqProfile => {
        return profile[reqProfile] === 1;
      });
    };
    const filteredPratiche = computed(() => {
      return pratiche.value.filter(pratica => {
        if (pratica.name === "Info Pratiche") { 
          const result = hasAccess(['all']);
          return result;
        }
        return true;
      });
    });
    
    onMounted(async () => {
      await Promise.all([
        getTypesStatoPratica(),
        getCountPraticheNonLavorate(),
        getCountPraticheStallo()
      ])
    });
    const has_selectedPratica = computed(()=>{
      return pratiche.value.some(pratica => pratica.selected) 
    })
    return {
      loader,
      file,
      pratiche,
      showComponent,
      currentComponent,
      currentData,
      stati,
      has_selectedPratica,
      visibleFilePratiche,
      filteredPratiche,
      praticheCounts,
      getCount,
      stalloCount,
    };
  },
};
</script>
<style>
  .btn-filter{
    font-size: 1.3rem !important;
    border-radius: 20px !important;
    width: 140px;
    height: 75px;
    opacity: 0.5;
    transition: opacity 0.2s ease-in-out;
  }
  .btn-filter:hover {
    opacity: 1;
  }
  .btn-filter.selected {
    opacity: 1;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
  .badge-notifica {
    color: #fff;
    border-radius: 999px;
    padding: 0 0.4rem;
    margin-left: 0.35rem;
    font-size: 0.75rem;
    min-width: 18px;
    text-align: center;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }
  .badge-notifica.badge-pod {
    background-color: #faad14;
  }
  .badge-notifica.badge-pdr {
    background-color: #ff4d4f;
  }
  .badge-notifica.badge-stallo {
    background-color: #1890ff;
  }
</style>
